import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import SingleNoteDom from '../../../components/Notes/SingleNote'
import * as StoresActions from '../../../actions/stores'

class SingleNote extends PureComponent {
    static propTypes = {
        index: PropTypes.number.isRequired,
        note: PropTypes.shape({}).isRequired,
        onChangeNote: PropTypes.func.isRequired,
        onChangeNoteImage: PropTypes.func.isRequired,
        onSubmitNote: PropTypes.func.isRequired,
        editNote: PropTypes.func.isRequired,
        deleteNote: PropTypes.func.isRequired,
        valueImage: PropTypes.shape({}),
        valueNote: PropTypes.string.isRequired,
    }

    onClickDelete = (id, parentID) => {
        const { deleteNote } = this.props
        deleteNote(id, parentID)
    }

    onClickSticky = (note, index) => {
        const { editNote } = this.props
        const noteToEdit = note
        noteToEdit.sticky = !noteToEdit.sticky
        editNote(noteToEdit, index)
    }

    render() {
        const { index, note, onChangeNoteImage, onChangeNote, onSubmitNote, valueImage, valueNote } = this.props

        return (
            <SingleNoteDom
                note={note}
                onClickSticky={this.onClickSticky}
                onClickDelete={this.onClickDelete}
                index={index}
                onChangeNote={onChangeNote}
                onChangeNoteImage={onChangeNoteImage}
                onSubmitNote={onSubmitNote}
                valueImage={valueImage}
                valueNote={valueNote}
            />
        )
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...StoresActions,
        },
        dispatch
    )

export default connect(null, mapDispatchToProps)(SingleNote)
